import React from 'react'
import { Checkbox as CheckboxControl, FormControlLabel, FormGroup, Box } from '@material-ui/core';

const Checkbox = ({onChange, value, ...props}) => {
    return (
        <Box pt={3}>
            <FormGroup row>
                <FormControlLabel
                    label={props.label || ''}
                    control={
                        <CheckboxControl
                        key={`field_inner_${props.name}`}
                        name={props.name}
                        checked={ !! value }
                        onChange={ (ev) => onChange(ev.target.name, ev.target.checked) }
                        color={props.color || 'primary'}
                        required={!! props.required}
                        disabled={!! props.disabled}
                        />
                    }
                    />
            </FormGroup>
        </Box>
    )
}

export default Checkbox;